module.exports = __webpack_public_path__ + "img/firework.06e98b3b.svg";